/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable no-console */
/* eslint-disable camelcase */
import { useCallback, useEffect, useState } from 'react'
import useSyncLocalStorage from '../../hooks/useSyncLocalStorage'

const LOCAL_STORAGE_KEY = 'membershipStorage'

type MembershipStorage = {
  customer_id: string;
  membership_id?: string;
  membership_status?: string;
  first_name: string;
  last_name: string;
  email: string;
};

const emptyStorage: MembershipStorage = {
  customer_id: '',
  first_name: '',
  last_name: '',
  email: '',
}

// eslint-disable-next-line import/prefer-default-export
export const useMembershipStorage = () => {
  const [membershipStorage, setMembershipStorageState] = useState(emptyStorage)

  useEffect(() => {
    let initialValue
    if (__BROWSER__ && window) {
      initialValue = window.localStorage.getItem(LOCAL_STORAGE_KEY)
    }
    let initialStorage = emptyStorage
    try {
      if (initialValue) {
        initialStorage = JSON.parse(initialValue)
      }
    } catch (err) {
      initialStorage = emptyStorage
    }
    setMembershipStorageState(initialStorage)
  }, [])

  const setMembershipStorage = useCallback((newValue: MembershipStorage) => {
    if (__BROWSER__ && window) {
      try {
        const storageItem = JSON.stringify(newValue)
        window.localStorage.setItem(LOCAL_STORAGE_KEY, storageItem)
        window?.flutter_inappwebview?.callHandler('sendMembershipStatusToApp', "", storageItem)
        setMembershipStorageState(newValue)
      } catch (err) {
        setMembershipStorageState(emptyStorage)
      }
    }
  }, [])

  useSyncLocalStorage(
    LOCAL_STORAGE_KEY,
    setMembershipStorageState,
  )

  const upsertMembershipStorage = useCallback((upsertMembership: MembershipStorage) => {
    if (!upsertMembership) {
      return
    }

    try {
      setMembershipStorage(upsertMembership)
    } catch (error) {
      console.error(error)
    }
  },
  [setMembershipStorage])

  const deleteMembershipStorage = useCallback(() => {
    try {
      setMembershipStorage(emptyStorage as MembershipStorage)
    } catch (error) {
      console.error(error)
    }
  }, [setMembershipStorage])

  return {
    upsertMembershipStorage,
    deleteMembershipStorage,
    membershipRecord: membershipStorage,
    membershipStorage,
  }
}
